<mat-icon class="user-inactive-icon" svgIcon="inactive" />
